export default __webpack_public_path__ + "static/media/card1.56e78874.png";